<template>
  <v-navigation-drawer
    app color="grey800"
    left
    v-bind="sidebarAttributes"
    class="sidebar"
    touchless
    @input="setChatOpen"
  >
    <Chat />
  </v-navigation-drawer>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import Chat from '@/components/Chat/Chat'

export default {
  components: { Chat },
  computed: {
    ...mapGetters(['ui']),
    open: {
      get() {
        return this.ui.chat.open
      },
      set(val) {
        this.setChatOpen(val)
      },
    },
    sidebarAttributes() {
      const isMobile = this.$vuetify.breakpoint.xs
      const isOpen = this.open

      const { lgAndDown } = this.$vuetify.breakpoint
      const isBackpackOpen = this.ui.sidebar.open

      return {
        value: isOpen,
        floating: true,
        temporary: isMobile ? false : (isBackpackOpen && lgAndDown),
        clipped: !isMobile,
        width: isMobile ? '100%' : 340,
        fixed: true,
      }
    },
  },
  methods: {
    ...mapMutations({
      setChatOpen: 'setChatOpen',
    }),
  },
}
</script>

<style lang="scss" scoped>
  .sidebar ::v-deep .v-navigation-drawer__content {
    display: flex;
    flex-direction: column;
    height: 100%;
  }
</style>
